module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/online/school-bdb972daa23e99d643243a464a871f2e.jpeg";